import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { FontFamily, TypographyV2 } from "config/font";

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-family: ${FontFamily.SpaceGroteskBold}, Helvetica;
  font-size: 24px;
  font-weight: 700;
  line-height: normal;
  color: ${ColorV2.Blue1};
`;

export const SectionDescription = styled.p`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue4};
  margin: 0;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RadioOption = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
`;

export const HiddenRadio = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 0;
  height: 0;
`;

export const RadioControl = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 999px;
  border: 2px solid ${ColorV2.Blue1};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${ColorV2.White};

  ${RadioOption} ${HiddenRadio}:checked + &::after {
    content: "";
    width: 10px;
    height: 10px;
    border-radius: 999px;
    background: ${ColorV2.Blue1};
  }
`;

export const RadioLabel = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue1};
`;
